import React from "react";

interface AuthContextType {
  // Define the shape of your auth context here, for example:
  // user: User | null;
  // login: (credentials: Credentials) => Promise<void>;
  // logout: () => void;
}

const AuthContext = React.createContext<AuthContextType | null>(null);

export default AuthContext;
